import { useLocation } from 'react-router-dom'

export function useGetSearchParams(requiredParams: string[]) {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const params = requiredParams.reduce(
    (acc, param) => {
      const value = searchParams.get(param)
      if (value !== null) {
        acc[param] = value
      }
      return acc
    },
    {} as { [key: string]: string },
  )

  return params
}
